/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-up': {
    width: 13,
    height: 8,
    viewBox: '0 0 13 8',
    data: '<path pid="0" d="M.5 6.959c0-.138.049-.277.147-.382L6.145.658A.485.485 0 0 1 6.5.5c.134 0 .261.057.355.158l5.498 5.919a.57.57 0 0 1 0 .765.477.477 0 0 1-.71 0L6.5 1.805 1.357 7.341a.477.477 0 0 1-.71 0A.561.561 0 0 1 .5 6.96z" _fill="#737373" fill-rule="nonzero"/>'
  }
})
